import { useQuery } from "@tanstack/react-query";
import { getRollLayouts } from "../repositories/RollLayoutsRepository";

interface UseRollLayoutsParams {
	standNumber: number;
	enabled?: boolean;
}

export const useRollLayouts = ({
	standNumber,
	enabled = true,
}: UseRollLayoutsParams) => {
	return useQuery({
		queryKey: ["rollLayouts", standNumber],
		queryFn: ({ signal }) => getRollLayouts({ standNumber, signal }),
		enabled: enabled && !!standNumber,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
